import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const ExpandableText = (props) => {
    var _a;
    const [stateExpanded, setExpanded] = React.useState(false);
    const [stateOverflowing, setOverflowing] = React.useState(false);
    const ref = React.useRef(null);
    React.useLayoutEffect(() => {
        const el = ref.current;
        if (el && !stateExpanded)
            setOverflowing(el.scrollHeight > el.clientHeight + 1);
    }, [props.text, stateExpanded]);
    return (_jsxs(_Fragment, { children: [_jsx("p", { ref: ref, className: `${(_a = props.className) !== null && _a !== void 0 ? _a : ''}${stateExpanded ? '' : ' text-clamp'}`.trim(), children: props.text }), stateOverflowing &&
                _jsx("button", { type: "button", className: "btn btn-link btn-sm p-0 text-decoration-none small mt-1", onClick: () => setExpanded(x => !x), children: stateExpanded ? 'Read less' : 'Read more' })] }));
};
export default ExpandableText;
